import { Injectable } from '@angular/core';

import { environment } from '@/environments/environment';
import { FeatureFlags } from '@/environments/environment.type';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  readonly flags: FeatureFlags = environment.features;
}
